import { createSlice  } from "@reduxjs/toolkit";
import { RootState } from "./reducer";
import { Item, Product } from "../utils/types";

interface popupType {
  itemId: number
  items: Item[]
  products: Product[],
  productId: number,
  isModalOpenEventSent: boolean,
  isNextEnable: boolean
}

const initialState: popupType = {
  itemId: -1,
  items: [],
  productId: -1,
  products: [],
  isModalOpenEventSent: false,
  isNextEnable: true
};

const slice = createSlice({
  name: "popup",
  initialState,
  reducers: {
    setPopupItemId: (popup, action) => {
      popup.itemId = action.payload;
    },
    setPopupItems: (popup, action) => {
      popup.items = action.payload;
    },
    setIsModalOpenEventSent: (popup, action) => {
      popup.isModalOpenEventSent = action.payload;
    },
    updatePopItemLink: (popup, action) => {
      const { itemId, linkId, properties } = action.payload;
      const item = popup.items.find(el => el.id === itemId);
      const linkIndex = item.links.findIndex(el => el.id === linkId);
      const link = item.links[linkIndex];
      item.links[linkIndex] = Object.assign({}, link, properties);      
    },
    changePopupItem: (popup, action) => {
      const { payload: direction } = action;
      const currentIndex = popup.items.findIndex(el => el.id === popup.itemId);
      
      if (direction === "next" && currentIndex < popup.items.length) {
        popup.itemId = popup.items[currentIndex + 1].id;
      }  
      
      if (direction === "previous" && currentIndex > 0) {
        popup.itemId = popup.items[currentIndex - 1].id;
      }
    },
    setPopupProductId: (popup, action) => {
      popup.productId = action.payload;
    },
    setProducts: (popup, action) => {
      popup.products = action.payload;
    }
  }
});

export const { setPopupItemId, setPopupItems, updatePopItemLink, changePopupItem, setProducts, setPopupProductId, setIsModalOpenEventSent } = slice.actions;
export default slice.reducer;

export const getPopupItem = (state: RootState) => {
  const item = state.popup.items.find((item: Item) => item.id === state.popup.itemId);
  return item !== undefined ? item : null;
};

export const getPopupFreeflowItems = (state: RootState) => {
  return [...state.popup.items.filter(item => item.source !== "upload_widget")];
};

export const getPopupProduct = (state: RootState) => {
  const product = state.popup.products.find((product: Product) => product.id === state.popup.productId);
  return product !== undefined ? product : null;
};

export const directBuyIsOpen = (state: RootState) => {
  return state.popup.productId !== -1;
};

export const isPreviousEnable = (state: RootState) => {
  const currentIndex = state.popup.items.findIndex(el => el.id === state.popup.itemId);
  const previos = state.popup.items[currentIndex - 1];
  return previos && previos.source !== "upload_widget";
};

export const isNextEnable = (state: RootState) => {
  const currentIndex = state.popup.items.findIndex(el => el.id === state.popup.itemId);
  const next = state.popup.items[currentIndex + 1];
  return next && next.source !== "upload_widget";
};